export const INSTANCES = Object.freeze({
    MODAL: 'OVERLAY_MODAL',
});

export const MODAL_CONFIG = {
    MODAL_CHOICE: {
        fn: 'invokeDialog',
        props: {
            title: 'Der Service ist momentan leider nicht verfügbar.',
            description: 'Gerne hilft Ihnen unser Bildungsberater persönlich weiter, unter der Telefonnummer 043 268 26 26. Bitte beachten Sie unsere Öffnungszeiten.',
        },
        facets: ['choice'],
    },
};
